<template>
  <div class="modal fade" id="modalUpdateStatusCommentResult" style="z-index: 1600" tabindex="-1" aria-labelledby="modalUpdateStatusCommentResult" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title w-100 text-center fw-bold">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <p class="text-center my-3">{{ textContent }}</p>
        <div class="modal-footer d-flex justify-content-center">
          <Button :title="translate('close')" :type="'secondary'" data-bs-dismiss="modal" class="me-2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { computed } from 'vue'
const props = defineProps({
  resultSuccess: {
    type: Boolean,
    default: true,
  },
  commentPublished: {
    type: Boolean,
    default: false,
  },
})

const title = computed(() => (props.commentPublished ? translate('publicCommentAdmin') : translate('privateChangedCommentAdmin')))

const textContent = computed(() => {
  const { resultSuccess, commentPublished } = props

  if (resultSuccess && commentPublished) return translate('OD65PublishSuccess')
  if (resultSuccess && !commentPublished) return translate('OD65PrivateSuccess')
  if (!resultSuccess && commentPublished) return translate('OD65PublishError')
  return translate('OD65PrivateError')
})
</script>
